import * as actionTypes from './actionTypes.js';
export const leftNavOpenReducer = (state = true, action) => {
    switch (action.type) {
        case actionTypes.TOGGLE_LEFT_NAV_OPEN:
            return !state;
        default:
            return state;
    }
};
export const rightNavOpenReducer = (state = false, action) => {
    switch (action.type) {
        case actionTypes.TOGGLE_RIGHT_NAV_OPEN:
            return !state;
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map